import pinyin from 'pinyin';
import * as _ from "lodash";

/**
 * 根据数据源表获取表格树结构
 * @param {Number} pid   -   父ID
 * @param {Object[]} list  -   数据源（含pid sort）
 * @returns {Object[]}
 */
const getTableTree = (pid, list) => {
    return list.filter(e => e.pid === pid).sort((a, b) => a.sort - b.sort).map(e => {
        e.children = getTableTree(e.id, list);
        return e;
    });
};

/**
 * 根据数据源表获取级联选择树结构
 * @param {Number} pid  - 父ID
 * @param {Object[]} list - 数据源（含pid sort）
 * @param {Number} excludeId - 排除的ID
 * @returns {Object[]}
 */
const getSelectTree = (pid, list, excludeId = null) => {
    return list.filter(e => e.pid === pid && e.id !== excludeId).sort((a, b) => a.sort - b.sort).map(e => {
        return {
            value: e.id,
            label: e.name,
            children: getSelectTree(e.id, list, excludeId)
        }
    });
};

/**
 * 根据数据源表获取默认级联选择
 * @param {Number} id
 * @param {Object[]} list
 * @returns {Array}
 */
const getSelectDefaultValue = (id, list) => {
    let item = list.find(e => e.id === id);
    if (item) {
        return [...getSelectDefaultValue(item.pid, list), id];
    } else {
        return [];
    }
};

/**
 * 解析大写首字母
 * @param {String} val
 * @returns {String}
 */
const parseInitial = (val) => {
    try {
        let parArr = pinyin(val, {
            style: pinyin.STYLE_FIRST_LETTER
        });
        if (!(_.isArray(parArr) && parArr.length !== 0)) return '';
        return _.toUpper(parArr[0][0].split('')[0]);
    } catch (e) {
        return '';
    }
};

/**
 * 根据模板克隆对象
 * @param {Object} modal - 模板对象
 * @param {Object} target - 目标对象
 * @param {Object} source - 源数据
 * @returns {Object} - 返回目标对象
 */
const cloneWithModal = (modal, target = null, source = null) => {
    target = target || {};
    source = source || {};
    Object.entries(modal).forEach(([k, v]) => {
        if (source.hasOwnProperty(k)) {
            if (_.isObject(v) && !_.isArray(v)) {
                target[k] = cloneWithModal(v, null, source[k]);
            } else {
                target[k] = _.cloneDeep(source[k]);
            }
        } else {
            target[k] = _.cloneDeep(v);
        }
    });
    return target;
};

const clone = (target = null, source = null) => {
    target = target || {};
    source = source || {};
    Object.entries(target).forEach(([k, v]) => {
        if (source.hasOwnProperty(k)) {
            if (_.isObject(v) && !_.isArray(v)) {
                target[k] = cloneWithModal(v, null, source[k]);
            } else {
                target[k] = _.cloneDeep(source[k]);
            }
        } else {
            target[k] = _.cloneDeep(v);
        }
    });
    return target;
};

export {getTableTree, getSelectTree, getSelectDefaultValue, parseInitial, cloneWithModal, clone};

export default {getTableTree, getSelectTree, getSelectDefaultValue, parseInitial, cloneWithModal, clone};
